<div>
  <div>
    <span class="pageHeader" id="adminReportsHeader">Reports</span>
  </div>
  <br>

  <div>
    <div class="repTblAlign">
      <table>
        <tr>
          <td><B>LookupTable Reports</B></td>
        </tr>
        <tr>
          <td><a class="reports-links" role="button" (click)="onReportClick('RPT_111','111-Contract Table By Seller Number')" > Contract Table By Seller Number</a></td>
        </tr>
        <tr>
          <td><a class="reports-links" role="button" (click)="onReportClick('RPT_112','112-Contract Table By Contract Number')" >Contract Table By Contract Number</a></td>
        </tr>
        <tr>
          <td><a class="reports-links" role="button" (click)="onReportClick('RPT_113','113-Seller Servicer Table By Number')" >Seller Servicer Table By Number</a></td>
        </tr>
        <tr>
          <td><a  class="reports-links" role="button" (click)="onReportClick('RPT_114','114-Seller Servicer Table By Name')" >Seller Servicer Table By Name(Partial Names also accepted)</a></td>
        </tr>
        <tr>
          <td><a  class="reports-links" role="button" (click)="onReportClick('RPT_115','115-Index Rate Table')">Index Rate Table</a></td>
        </tr>
        <br>
      </table>
    </div>
  </div>
</div>
  <br><br>
